





















































































































// Vue
import Vue from "vue";
import { validationMixin } from "vuelidate";
import { email, required, sameAs, minLength } from "vuelidate/lib/validators";
// Services
import AuthService from "@/core/services/auth.service";
import { _Error } from "@/core/_models/_error.model";

export default Vue.extend({
  mixins: [validationMixin],
  name: "ResetPassword",
  data() {
    return {
      isLoading: false,
      valid: false,
      email: "",
      newPassword: "",
      confirmPassword: "",
      token: "",
      successResetPassword: false,
      errorResetPassword: false
    };
  },
  validations: {
    email: { required, email },
    newPassword: {
      required,
      minLength: minLength(6),
      containsUppercase: function (value) {
        return /[A-Z]/.test(value);
      },
      containsLowercase: function (value) {
        return /[a-z]/.test(value);
      },
      containsNumber: function (value) {
        // This regular expression checks if the value contains at least one digit (0-9)
        return /[0-9]/.test(value);
      },
      containsSpecial: function (value) {
        return /[^a-zA-Z0-9]/.test(value);
      }
    },
    confirmPassword: { required, sameAsPassword: sameAs("newPassword") }
  },
  mounted() {
    // Grab query params from URL
    this.email = (this.$route.query.e as string) || "";
    this.token = (this.$route.query.t as string) || "";
  },
  methods: {
    /**
     * Sends a password reset link to the email provided.
     *
     * @author Nick Brahimir
     */
    submitPassword: function (): void {
      this.isLoading = true;
      this.successResetPassword = false;

      AuthService.resetPassword(this.email, this.newPassword, this.token)
        .then((data: boolean) => {
          // Check for null data response.
          if (!data) {
            this.errorResetPassword = true;
            return;
          }
          // Password email successfully sent.
          this.successResetPassword = true;
        })
        .then(() => {
          this.isLoading = false;
        });

      this.clearForm;
    },
    /**
     * Clears the form.
     *
     */
    clearForm: function (): void {
      this.$v.$reset();
      this.email = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.token = "";
    }
  },
  computed: {
    /**
     * Parses any email errors.
     *
     */
    emailErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Please enter a valid email");
      return errors;
    },
    passwordErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.newPassword.$dirty) return errors;
      !this.$v.newPassword.required && errors.push("Password is required");
      !this.$v.newPassword.minLength && errors.push("Password must be at least 6 characters long");
      !this.$v.newPassword.containsNumber && errors.push("Password must contain at least one number");
      !this.$v.newPassword.containsSpecial &&
        errors.push("Password must contain at least one non-alphanumeric character.");
      !this.$v.newPassword.containsUppercase &&
        errors.push("Password must contain at least one upper case letter.");
      !this.$v.newPassword.containsLowercase &&
        errors.push("Password must contain at least one lower case letter.");
      return errors;
    },
    confirmPasswordErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.confirmPassword.$dirty) return errors;
      !this.$v.confirmPassword.required && errors.push("Please confirm your password");
      !this.$v.confirmPassword.sameAsPassword && errors.push("Passwords do not match");
      return errors;
    }
  }
});
